import React, { useEffect, useState, useContext } from "react";
import {
  Table,
  Spinner,
  Alert,
  Container,
  Card,
  Button,
  Form,
  Row,
  Col,
} from "react-bootstrap";
import { ThemeContext } from "contexts/ThemeContext.jsx";
import { serverHost } from "variables/serverdata";
import { Input } from "reactstrap";
import HucsHeader from "../components/HusariaHeader";

const DestinationSummary = () => {
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const [destinations, setDestinations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // Filter states
    const [quickSelect, setQuickSelect] = useState("3");
    const [startDateTime, setStartDateTime] = useState("");
    const [endDateTime, setEndDateTime] = useState("");

    const fetchDestinations = async () => {
        setLoading(true);
        setError(null);
        try {
            const site = JSON.parse(localStorage.getItem("selectedSite"));
            let body = {
                qs: quickSelect
            }
            if (startDateTime) body["startTime"] = startDateTime;
            if (endDateTime) body["endTime"] = endDateTime;

            const response = await fetch(
                `${serverHost}/dest_summary/${site.site_uuid}`, {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body)
                }
            );
            if (!response.ok) throw new Error("Failed to fetch destination summary");
            const data = await response.json();
            console.log(data.result)
            setDestinations(data.result || []);
            console.log("Destination summary fetched");
        } catch (err) {
        setError(err.message);
        } finally {
        setLoading(false);
        }
    };

    const handleUpdate = () => {
        fetchDestinations();
    };

    const handleFilterReset = () => {
        setQuickSelect("today");
        setStartDateTime("");
        setEndDateTime("");
    };

    const handleDownloadCSV = () => {
        // Create CSV content
        const headers = [
        "Destination",
        "Answered",
        "Unique Callers",
        "Total Calls",
        "Duration",
        "Description",
        ];
        const rows = destinations.map((dest) => [
        dest.destination || "",
        dest.answered || 0,
        dest.unique_callers || 0,
        dest.total_calls || 0,
        dest.duration || "",
        dest.description || "",
        ]);

        const csvContent = [
        headers.join(","),
        ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")),
        ].join("\n");

        // Create download link
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);

        link.setAttribute("href", url);
        link.setAttribute(
        "download",
        `destination_summary_${new Date().toISOString().split("T")[0]}.csv`
        );
        link.style.visibility = "hidden";

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        fetchDestinations();
    }, []);

    const formatDuration = (seconds) => {
        if (!seconds) return "0:00";
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (hrs > 0) {
        return `${hrs}:${mins.toString().padStart(2, "0")}:${secs
            .toString()
            .padStart(2, "0")}`;
        }
        return `${mins}:${secs.toString().padStart(2, "0")}`;
    };

    return (
        <>
        <HucsHeader name="Destination Summary" parentName="HUCS" padding="9rem"/>

        <Container fluid className="mt--8">
            {/* Filter Controls */}
            <Card
                className={`shadow-sm ${
                    isDark ? "bg-dark text-light border-dark" : ""
                }`} 
                style={{
                    borderRadius: "1rem",
                    overflow: "hidden", 
                }}
            >
            <Card.Body style={{ backgroundColor: isDark ? "#1f2937" : "#fff"}}>
                <Row className="align-items-end">
                <Col md={3} className="mb-3 mb-md-0">
                    <Form.Group>
                    <Form.Label
                        style={{
                        color: isDark ? "#e2e8f0" : "#212529",
                        fontWeight: 600,
                        }}
                    >
                        Quick Select
                    </Form.Label>
                    <Input
                        type="select"
                        value={quickSelect}
                        onChange={(e) => setQuickSelect(e.target.value)}
                        style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#212529",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                        }}
                    >
                        <option value="0"></option>
                        <option value="1">Last 7 Days</option>
                        <option value="2">Last Hour</option>
                        <option value="3" selected="selected">Today</option>
                        <option value="4">Yesterday</option>
                        <option value="5">This Week</option>
                        <option value="6">This Month</option>
                        <option value="7">This Year</option>
                    </Input>
                    </Form.Group>
                </Col>

                <Col md={3} className="mb-3 mb-md-0">
                    <Form.Group>
                    <Form.Label
                        style={{
                        color: isDark ? "#e2e8f0" : "#212529",
                        fontWeight: 600,
                        }}
                    >
                        Start Date/Time
                    </Form.Label>
                    <Form.Control
                        type="datetime-local"
                        value={startDateTime}
                        onChange={(e) => {
                            setStartDateTime(e.target.value);
                        }}
                        style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#212529",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                        }}
                    />
                    </Form.Group>
                </Col>

                <Col md={3} className="mb-3 mb-md-0">
                    <Form.Group>
                    <Form.Label
                        style={{
                        color: isDark ? "#e2e8f0" : "#212529",
                        fontWeight: 600,
                        }}
                    >
                        End Date/Time
                    </Form.Label>
                    <Form.Control
                        type="datetime-local"
                        value={endDateTime}
                        onChange={(e) => {
                            setEndDateTime(e.target.value);

                        }}
                        style={{
                        backgroundColor: isDark ? "#374151" : "#fff",
                        color: isDark ? "#e2e8f0" : "#212529",
                        borderColor: isDark ? "#4b5563" : "#ced4da",
                        }}
                    />
                    </Form.Group>
                </Col>

                <Col md={3} className="mb-3 mb-md-0">
                    <div
                    style={{
                        paddingLeft: "6rem",
                    }}
                    className="d-flex gap-2 flex-wrap"
                    >
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleUpdate}
                        disabled={loading}
                    >
                        {loading ? "Updating..." : "Update"}
                    </Button>
                    <Button
                        variant="success"
                        size="sm"
                        onClick={handleDownloadCSV}
                        disabled={destinations.length === 0}
                    >
                        Download CSV
                    </Button>
                    <Button
                        size="sm"
                        variant="light"
                        onClick={handleFilterReset}
                    >
                        Reset
                    </Button>
                    </div>
                </Col>
                </Row>
            </Card.Body>
            </Card>

            {/* Destination Summary Table */}
            <Card
            className={`shadow-sm ${
                isDark ? "bg-dark text-light border-dark" : ""
            }`}
            >
            <Card.Header
                style={{
                backgroundColor: isDark ? "#1f2937" : "#f0f0f0",
                color: isDark ? "#e2e8f0" : "#111",
                }}
            >
                <div className="d-flex justify-content-between align-items-center">
                {loading && (
                    <Spinner
                    animation="border"
                    size="sm"
                    variant={isDark ? "light" : "primary"}
                    />
                )}
                </div>
            </Card.Header>

            <Card.Body
                style={{ padding: 0, backgroundColor: isDark ? "#1f2937" : "#fff" }}
            >
                {error ? (
                <Alert variant="danger" className="m-3">
                    {error}
                </Alert>
                ) : destinations.length === 0 ? (
                <div
                    className="text-center py-5"
                    style={{ color: isDark ? "#9ca3af" : "#6c757d" }}
                >
                    <h5>No data available</h5>
                    <p className="mb-0">
                    No destination data found for the selected time range.
                    </p>
                </div>
                ) : (
                <div style={{ overflowX: "auto" }}>
                    <Table
                    striped
                    hover
                    responsive
                    bordered
                    className="mb-0"
                    style={{
                        minWidth: "1000px",
                        backgroundColor: isDark ? "#1f2937" : "#fff",
                        color: isDark ? "#e2e8f0" : "#212529",
                    }}
                    >
                    <thead
                        style={{
                        backgroundColor: isDark ? "#1f2937" : "#fff",
                        fontWeight: "bold",
                        color: isDark ? "#e2e8f0" : "#212529",
                        }}
                    >
                        <tr>
                        <th className="text-center">Destination</th>
                        <th className="text-center">Answered</th>
                        <th className="text-center">Unique Callers</th>
                        <th className="text-center">Total Calls</th>
                        <th className="text-center">Duration</th>
                        <th className="text-center">Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        {destinations.map((dest, index) => (
                        <tr
                            key={index}
                            style={{ color: isDark ? "#e2e8f0" : "#212529" }}
                        >
                            <td
                            className="text-center"
                            style={{ fontWeight: 600, fontFamily: "monospace" }}
                            >
                            {dest.destination_number || "-"}
                            </td>
                            <td
                            className="text-center"
                            style={{ fontSize: "1rem", fontWeight: 500 }}
                            >
                            {dest.answered || 0}
                            </td>
                            <td
                            className="text-center"
                            style={{ fontSize: "1rem", fontWeight: 500 }}
                            >
                            {dest.unique_callers || 0}
                            </td>
                            <td
                            className="text-center"
                            style={{ fontSize: "1rem", fontWeight: 500 }}
                            >
                            {dest.total_calls || 0}
                            </td>
                            <td
                            className="text-center"
                            style={{ fontFamily: "monospace" }}
                            >
                            {formatDuration(dest.duration)}
                            </td>
                            <td className="text-center">
                            {dest.description || "-"}
                            </td>
                        </tr>
                        ))}
                    </tbody>
                    </Table>
                </div>
                )}
            </Card.Body>
            </Card>
        </Container>
        </>
    );
};

export default DestinationSummary;
